import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class JobProgressService {
  private progressSubject = new BehaviorSubject<number>(0);
  private isVisibleSubject = new BehaviorSubject<boolean>(false);

  progress$ = this.progressSubject.asObservable();
  isVisible$ = this.isVisibleSubject.asObservable();

  updateProgress(percentage: number): void {
    this.progressSubject.next(percentage);
  }

  setVisibility(visible: boolean): void {
    // Ensure progress resets when hiding
    if (!visible) {
      this.progressSubject.next(0);
    }
    this.isVisibleSubject.next(visible);
  }
}
